import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import GoogleButton from "../components/GoogleButton";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome back, ${res.user.name}`);
      const to = loc.state?.from || (res.user.role === "organizer" ? "/organizer" : "/");
      nav(typeof to === "string" ? to : "/");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-md items-center px-4 py-10">
      <div className="w-full rounded-3xl border border-zinc-800 bg-[#3A1020] p-8 glow-amber">
        <div className="mb-6">
          <div className="font-mono text-[10px] uppercase tracking-widest text-amber-400">Sign in</div>
          <h1 className="font-display text-3xl font-black uppercase text-zinc-50">Welcome back</h1>
          <p className="mt-2 text-sm text-zinc-400">Enter your credentials to continue.</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-widest text-zinc-400">Email</Label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 border-zinc-800 bg-[#2F0D18] text-zinc-100 placeholder:text-zinc-600" placeholder="you@example.com" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest text-zinc-400">Password</Label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 border-zinc-800 bg-[#2F0D18] text-zinc-100" placeholder="••••••••" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="h-11 w-full bg-amber-500 font-bold uppercase tracking-wider text-zinc-950 hover:bg-amber-400">
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>

        <div className="my-5 flex items-center gap-3 text-[10px] font-mono uppercase tracking-widest text-zinc-500"><span className="h-px flex-1 bg-zinc-800" />or<span className="h-px flex-1 bg-zinc-800" /></div>
        <GoogleButton />

        <div className="mt-6 text-center text-sm text-zinc-400">
          New here? <Link to="/register" className="font-semibold text-amber-400 hover:text-amber-300">Create an account</Link>
        </div>

        <div className="mt-6 rounded-xl border border-zinc-800 bg-[#2F0D18] p-3">
          <div className="mb-1 font-mono text-[10px] uppercase tracking-widest text-zinc-500">Demo accounts</div>
          <div className="space-y-1 text-xs text-zinc-400">
            <div><span className="font-mono text-amber-400">attendee@thehive.com</span> / Attendee@123</div>
            <div><span className="font-mono text-amber-400">organizer@thehive.com</span> / Organizer@123</div>
          </div>
        </div>
      </div>
    </div>
  );
}
